import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      roles: ['administrator'],
      component: () => import('../Wrapper'),
      props: {
        headerTitle: 'AGENT_BOTS.HEADER',
        icon: 'bot',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: () => import('./Index.vue'),
          roles: ['administrator'],
        },
        {
          path: 'csml/new',
          name: 'agent_bots_csml_new',
          component: () => import('./csml/New.vue'),
          roles: ['administrator'],
        },
        {
          path: 'csml/:botId',
          name: 'agent_bots_csml_edit',
          component: () => import('./csml/Edit.vue'),
          roles: ['administrator'],
        },
      ],
    },
  ],
};
